<div class="grid grid-cols-12 gap-3 auto-rows-min">

  <!-- Subscription status banner (auto-hides when healthy) -->
  <div class="col-span-12">
    <app-subscription-status-banner />
  </div>

  <!-- Welcome strip -->
  <div class="col-span-12 bg-white rounded-xl border border-gray-100 shadow-sm px-4 py-3 flex items-center justify-between">
    <div>
      <h1 class="text-lg font-semibold text-gray-900">
        {{ isAdmin() ? 'Committee Management' : 'Welcome back' }}<span class="text-gray-400 font-normal">, {{ userName() }}</span>
      </h1>
      <p class="text-xs text-gray-500">
        {{ isAdmin()
            ? 'Operational snapshot of your committee.'
            : 'Your membership and payments at a glance.' }}
      </p>
    </div>
    <div class="hidden sm:block text-xs text-gray-400">
      {{ currentMonth }}/{{ currentYear }}
    </div>
  </div>

  <!-- Member dues alert (partial payment / arrears) -->
  <div class="col-span-12">
    <app-member-dues-alert />
  </div>

  <!-- Event dues alert (unpaid/partial event contributions) -->
  <div class="col-span-12">
    <app-event-dues-alert />
  </div>

  @if (!canSeeStats()) {
    <div class="col-span-12">
      <app-no-bu-selected entityLabel="dashboard stats" />
    </div>
  } @else {

    <!-- KPI tiles -->
    @if (isLoading) {
      @for (i of (isAdmin() ? [1,2,3] : [1,2]); track i) {
        <div class="col-span-12 sm:col-span-4 lg:col-span-{{ isAdmin() ? '[8/3]' : '4' }} bg-white rounded-xl p-4 border border-gray-100 animate-pulse">
          <div class="h-3 bg-gray-200 rounded w-1/2 mb-3"></div>
          <div class="h-7 bg-gray-200 rounded w-3/4"></div>
        </div>
      }
    } @else if (isAdmin()) {
      <div class="col-span-12 sm:col-span-4 lg:col-span-3 bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
            <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
          </div>
          <p class="text-xs text-gray-500 font-medium">Total Members</p>
        </div>
        <p class="text-2xl font-bold text-gray-900">{{ totalMembers }}</p>
      </div>

      <div class="col-span-12 sm:col-span-4 lg:col-span-3 bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
            <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <p class="text-xs text-gray-500 font-medium">Revenue (month)</p>
        </div>
        <p class="text-2xl font-bold text-gray-900">Rs. {{ totalRevenue | number:'1.0-0' }}</p>
      </div>

      <div class="col-span-12 sm:col-span-4 lg:col-span-2 bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
            <svg class="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
            </svg>
          </div>
          <p class="text-xs text-gray-500 font-medium">Payments</p>
        </div>
        <p class="text-2xl font-bold text-gray-900">{{ thisMonthPayments }}</p>
      </div>
    } @else {
      <div class="col-span-12 sm:col-span-6 lg:col-span-4 bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
            <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <p class="text-xs text-gray-500 font-medium">My Total Paid (month)</p>
        </div>
        <p class="text-2xl font-bold text-gray-900">Rs. {{ totalRevenue | number:'1.0-0' }}</p>
      </div>

      <div class="col-span-12 sm:col-span-6 lg:col-span-4 bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
        <div class="flex items-center gap-2 mb-2">
          <div class="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
            <svg class="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
            </svg>
          </div>
          <p class="text-xs text-gray-500 font-medium">My Payments (month)</p>
        </div>
        <p class="text-2xl font-bold text-gray-900">{{ thisMonthPayments }}</p>
      </div>
    }

    @if (isAdmin()) {
      <div class="col-span-12 lg:col-span-8">
        <app-subscription-usage-card />
      </div>
    }

    <!-- Recent Activity right rail -->
    <div class="col-span-12 lg:col-span-4 lg:row-span-3 bg-white rounded-xl border border-gray-100 shadow-sm p-4 flex flex-col">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-semibold text-gray-900">Recent Activity</h3>
        @if (recentActivity().length > 0) {
          <span class="text-xs text-gray-400">{{ isAdmin() ? 'All users' : 'You' }}</span>
        }
      </div>

      @if (isLoadingActivity()) {
        <div class="space-y-2 flex-1">
          @for (i of [1,2,3,4,5,6]; track i) {
            <div class="flex items-start gap-2 animate-pulse">
              <div class="w-7 h-7 rounded-full bg-gray-200"></div>
              <div class="flex-1">
                <div class="h-3 bg-gray-200 rounded w-3/4 mb-1"></div>
                <div class="h-2 bg-gray-100 rounded w-1/3"></div>
              </div>
            </div>
          }
        </div>
      } @else if (recentActivity().length === 0) {
        <div class="flex-1 flex items-center justify-center text-xs text-gray-400">
          No activity yet.
        </div>
      } @else {
        <ul class="flex-1 space-y-2 overflow-y-auto pr-1">
          @for (entry of recentActivity(); track entry.id) {
            <li>
              <button type="button"
                      (click)="goToActivity(entry)"
                      class="w-full text-left flex items-start gap-2 p-2 rounded-lg hover:bg-gray-50 transition-colors">
                <div class="w-7 h-7 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-[10px] font-semibold flex-shrink-0">
                  {{ initials(entry.username) }}
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-xs text-gray-700 leading-snug">
                    <span class="font-medium">{{ entry.username || 'System' }}</span>
                    <span class="text-gray-500"> {{ verbFor(entry.action) }} </span>
                    <span class="font-medium text-gray-800">{{ entry.entityDisplayName || entry.entityType }}</span>
                  </p>
                  <p class="text-[10px] text-gray-400 mt-0.5" [title]="entry.timestamp">
                    {{ formatRelative(entry.timestamp) }}
                  </p>
                </div>
              </button>
            </li>
          }
        </ul>
      }
    </div>

    <!-- Quick actions strip -->
    <div class="col-span-12 lg:col-span-8 bg-white rounded-xl border border-gray-100 shadow-sm p-4">
      <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Quick actions</h3>
      <div class="flex flex-wrap gap-2">
        @if (isAdmin()) {
          <a routerLink="/members" class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-100 hover:bg-blue-50 hover:border-blue-200 transition-colors">
            <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
            <span class="text-sm font-medium text-gray-800">Members</span>
          </a>
        }
        <a *appHasPermission="[301, 302]" routerLink="/payments" class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-100 hover:bg-green-50 hover:border-green-200 transition-colors">
          <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          <span class="text-sm font-medium text-gray-800">Payments</span>
        </a>
        <a routerLink="/events" class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-100 hover:bg-purple-50 hover:border-purple-200 transition-colors">
          <svg class="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
          <span class="text-sm font-medium text-gray-800">Events</span>
        </a>
        <a *appHasPermission="[501]" routerLink="/reports" class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-100 hover:bg-amber-50 hover:border-amber-200 transition-colors">
          <svg class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/></svg>
          <span class="text-sm font-medium text-gray-800">Reports</span>
        </a>
        <a routerLink="/settings" class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-100 hover:bg-gray-100 transition-colors">
          <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
          <span class="text-sm font-medium text-gray-800">Settings</span>
        </a>
      </div>
    </div>

    <!-- Reserved widget slot -->
    <div class="col-span-12 lg:col-span-8 bg-white rounded-xl border border-gray-100 shadow-sm p-4 min-h-[140px] flex items-center justify-center text-xs text-gray-400">
      Monthly overview coming soon
    </div>
  }

</div>
